// @file Composable that provides actions for switching between whiteboard frames and handles prefetching images in play mode.
import { setSearchParam } from '@@/bits/location'
import { FRAME_ID_QUERY_PARAM } from '@@/bits/whiteboard'
import { useWhiteboardModeStore } from '@@/pinia/whiteboard_mode'
import { useTldrawEditor } from '@@/vuecomposables/useTldrawEditor'
import { prefetchImagesInAdjacentFrames } from '@@/vuecomposables/use_whiteboard_play_mode_prefetch_images'
import type { TLPageId } from 'tldraw'

export const useWhiteboardFrameActions = (): {
  switchFrame: (frameId: TLPageId) => void
} => {
  const whiteboardModeStore = useWhiteboardModeStore()

  const switchFrame = (frameId: TLPageId): void => {
    const editor = useTldrawEditor().editor
    if (editor == null) return
    editor.setCurrentPage(frameId)
    setSearchParam(FRAME_ID_QUERY_PARAM, frameId)

    if (whiteboardModeStore.isPlayMode) {
      prefetchImagesInAdjacentFrames(editor)
    }
  }

  return {
    switchFrame,
  }
}
